<template>
    <div class="breadcrumb-wrap">
        <b-container>
            <div class="breadcrumb-dropdown-wrap">
                <span class="breadcrumb-current" @click.stop></span>
                <div class="breadcrumb-dropdown">
                    <b-breadcrumb>
                        <b-breadcrumb-item
                            v-for="(page, index) in activePages"
                            :key="`page-${index}`"
                            :to="!('items' in page) ? index : null"
                            :class="{
                                'breadcrumb-drop-down': 'items' in page,
                                'router-link-active': ('items' in page)
                                    ? containsCurrentPage(page.items)
                                    : false
                            }"
                            :text="page.name || index"
                            @click.stop
                        >
                            <b-dropdown v-if="'items' in page" :text="page.name || index">
                                <b-dropdown-item
                                    v-for="(item, index) in page.items"
                                    :key="`page-items-${index}`"
                                    :to="{path: `/${index}`}"
                                    @click.stop
                                >
                                    {{item.name || index}}
                                </b-dropdown-item>
                            </b-dropdown>
                            {{
                                'items' in page
                                    ? null
                                    : page.name || index
                            }}
                        </b-breadcrumb-item>
                    </b-breadcrumb>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>
import {
    setTimeout
} from 'timers';
import { mapActions, mapState } from 'vuex';
import { MODULES } from '@constants';
import constants from '../constant';

const DASHBOARD = 'dashboard';
const VOLUNTEERING_HISTORY = 'volunteering-history';
const VOLUNTEERING_TIMESHEET = 'volunteering-timesheet';
const VOLUNTEERING_COMMENT = 'comment-history';
const DONATION_HISTORY = 'donation-dashboard';
const STORIES = 'my-stories';

export default {
    name: 'Breadcrumb',
    props: {
        breadcrumbActive: String
    },
    data() {
        return {
            pages: {
                [DASHBOARD]: {
                    name: this.getTrans('label.dashboard'),
                    active: true
                },
                volunteers: {
                    name: this.getTrans('label.volunteering'),
                    items: {
                        [VOLUNTEERING_HISTORY]: {
                            name: this.getTrans('label.history') || 'History--',
                            active: false
                        },
                        [VOLUNTEERING_TIMESHEET]: {
                            name: this.getTrans('label.timesheet'),
                            active: false
                        },
                        [VOLUNTEERING_COMMENT]: {
                            name: this.getTrans('label.comments'),
                            active: false
                        }
                    }
                },
                donations: {
                    name: this.getTrans('label.donations'),
                    items: {
                        [DONATION_HISTORY]: {
                            name: this.getTrans('label.history') || 'History--',
                            active: false
                        }
                    }
                },
                [STORIES]: {
                    name: this.getTrans('label.dashboard_my_stories'),
                    active: false
                }
            }
        };
    },
    computed: {
        activePages() {
            const actives = {};

            Object.keys(this.pages).filter(item => {
                if ('items' in this.pages[item]) {
                    return this.containsActiveItems(this.pages[item].items);
                }
                return this.pages[item].active;
            }).map(key => {
                actives[key] = this.pages[key];
            })

            return actives;
        }
    },
    methods: {
        handleBreadcrumb() {
            if (screen.width < 768) {
                let profileToggle = document.querySelector(
						".profile-menu .dropdown-toggle"
				);
				let profileMenu = document.querySelector(".profile-menu");
				if (profileMenu != null) {
					if (profileMenu.classList.contains("show")) {
						profileToggle.click();
					}
                }
                let notificationBtn = document.querySelector(
                    ".notification-menu .nav-link .btn-notification"
                );
                let notificationPopover = document.querySelector(".notification-popover");
                if (notificationPopover != null) {
                    notificationBtn.click();
                }
                let breadcrumbDropdown = document.querySelector(
                    '.breadcrumb-dropdown-wrap'
                );

                if (breadcrumbDropdown) {
                    breadcrumbDropdown.classList.toggle('open');
                }
            }
        },

        containsActiveItems(items) {
            return Object.keys(items).filter(item => {
                return items[item].active;
            }).length > 0;
        },

        containsCurrentPage(items) {
            return Object.keys(items).filter(item => {
                return this.$route.path === `/${item}`;
            }).length > 0;
        }
    },
    async created() {
        setTimeout(() => {
            if (document.querySelector('.breadcrumb') != null) {
                let currentDashboard = document.querySelector(
                    '.breadcrumb .router-link-active'
                );

                if (!currentDashboard) {
                    return;
                }

                this.currentDashboardPage = currentDashboard.innerHTML;
                let currentLink = document.querySelector('.breadcrumb-current');
                currentLink.innerHTML = this.currentDashboardPage;
                currentLink.addEventListener('click', this.handleBreadcrumb);
            }
        });

        const isGoalMissionActive = this.settingEnabled(constants.VOLUNTEERING_GOAL_MISSION);
        const isTimeMissionActive = this.settingEnabled(constants.VOLUNTEERING_TIME_MISSION);
        const isVolunteeringSettingEnabled = this.settingEnabled(constants.SETTING_VOLUNTEERING);
        const isDonationSettingEnabled = this.settingEnabled(constants.SETTING_DONATION);
        const isMissionCommentsSettingEnabled = this.settingEnabled(constants.MISSION_COMMENTS);
        const isDonationMissionCommentsSettingEnabled = this.settingEnabled(constants.SETTING_DONATION_MISSION_COMMENTS);
        const isStoriesSettingEnabled = this.settingEnabled(constants.STORIES_ENABLED);
        const displayVolunteeringPages = isVolunteeringSettingEnabled
            && (isGoalMissionActive || isTimeMissionActive);

        this.pages.volunteers.items[VOLUNTEERING_TIMESHEET].active = displayVolunteeringPages;
        this.pages.volunteers.items[VOLUNTEERING_COMMENT].active = (isMissionCommentsSettingEnabled || isDonationMissionCommentsSettingEnabled)

        this.pages.donations.items[DONATION_HISTORY].active = isDonationSettingEnabled;
        this.pages[STORIES].active = isStoriesSettingEnabled;

        this.handleBreadcrumb();
    }
};
</script>
